export const IMG_ALT = 'Terabet image';

export const MARKET_SPREADS = [
  'point_spread',
  'run_line',
  'puck_line',
  '1st_half_point_spread',
  '1st_half_run_line',
  '1st_period_puck_line',
  '2nd_half_point_spread',
  '2nd_period_puck_line',
  'first_half_point_spread',
  'first_half_run_line',
  'first_period_puck_line',
  'second_half_point_spread',
  'second_period_puck_line',
  'run_line_after_5_innings',
];
export const MARKET_TOTALS = [
  'total_runs',
  'total_points',
  'total_goals',
  'total_match_goals_over_under',
  'total_runs_over_under',
  'total_points_over_under',
  'total_goals_over_under',
];
export const MARKET_MONEYLINES = [
  'moneyline',
  'money_line',
  'match_result',
  'match_winner',
  'fight_result_draw_no_bet_',
];
export const TEASER_MARKET = ['point_spread', 'total_points'];
export const FOOTBALL_SPORT = 'Football';

export const BET_POINTS = [0.5, 1.5, 2.5, 3.5, 4.5];

export const PLACE_BET_AUDIO =
  'https://sport-team-logos.s3.ap-southeast-1.amazonaws.com/place_bet_sound.mp3';

export interface MoreWagersProps {
  title: string;
  markets: string[];
}

export const MORE_WAGERS_FIRST_HALF: MoreWagersProps[] = [
  {
    title: 'moreWagersFirstHalf.spread',
    markets: [
      '1st_half_point_spread',
      '1st_half_run_line',
      '1st_period_puck_line',
      'first_half_point_spread',
      'first_half_run_line',
      'first_period_puck_line',
      'run_line_after_5_innings',
    ],
  },
  {
    title: 'moreWagersFirstHalf.money',
    markets: [
      '1st_half_moneyline',
      '1st_period_moneyline',
      'first_half_money_line',
      'first_period_money_line',
      'first_5_innings_money_line',
    ],
  },
  {
    title: 'moreWagersFirstHalf.total',
    markets: [
      '1st_half_total_points',
      '1st_half_total_runs',
      '1st_period_total_goals',
      'first_half_total_points',
      'first_half_total_runs',
      'first_period_total_goals',
      'first_period_total_goals_over_under',
      'first_half_total_points_over_under',
      'total_runs_after_5_innings_over_under',
    ],
  },
];

export const MORE_WAGERS_SECOND_HALF: MoreWagersProps[] = [
  {
    title: 'moreWagersSecondHalf.spread',
    markets: [
      '2nd_half_point_spread',
      '2nd_period_puck_line',
      'second_half_point_spread',
      'second_period_puck_line',
    ],
  },
  {
    title: 'moreWagersSecondHalf.money',
    markets: [
      '2nd_half_moneyline',
      '2nd_period_moneyline',
      'second_half_money_line',
      'second_period_money_line',
    ],
  },
  {
    title: 'moreWagersSecondHalf.total',
    markets: [
      '2nd_half_total_points',
      '2nd_period_total_goals',
      'second_half_total_points',
      'second_period_total_goals',
      'second_period_total_goals_over_under',
      'second_half_total_points_over_under',
    ],
  },
];

export const WAGERS_PLAYER_PROPS: string[] = [
  'player_passing_yards',
  'player_receiving_yards',
  'player_rushing_yards',
  'player_field_goals_made',
  'player_passing_attempts',
  'player_passing_completions',
  'player_receptions',
  'player_rushing_+_receiving_yards',
  'player_passing_touchdowns',
  'player_touchdowns',
  'player_assists',
  'player_blocks',
  'player_double_double',
  'player_made_threes',
  'player_points',
  'player_points_+_assists',
  'player_points_+_rebounds',
  'player_points_+_rebounds_+_assists',
  'player_rebounds',
  'player_rebounds_+_assists',
  'player_steals',
  'player_steals_+_blocks',
  'player_triple_double',
  'player_turnovers',
  'player_field_goals_attempted',
  'player_free_throws_made',
  'player_rebounds_combo_',
  'player_assists_combo_',
  'player_defensive_rebounds',
  'player_dunks',
  'player_fantasy_score_prizepicks_',
  'player_minutes_played',
  'player_fantasy_points_betr_',
  'player_fantasy_score_underdog_',
  'player_free_throws_attempted',
  'player_made_two_pointers',
  'player_threes_attempted',
  'player_two_pointers_attempted',
  'player_goals',
  'player_saves',
  'player_shots_on_goal',
  'player_power_play_points',
  'player_blocked_shots',
  'player_shots_on_target',
  'player_games_won',
  'player_hits',
  'player_strikeouts',
  'player_home_runs',
  'player_doubles',
  'player_walks',
  'player_hits_allowed',
  'player_bases',
  'player_outs',
  'player_stolen_bases',
  'player_to_record_win',
  'player_singles',
  'player_earned_runs',
  'player_triples',
  'player_rbis',
  'player_runs',
  'player_hits_ + _runs_ + _rbis',
  'player_batting_strikeouts',
  'player_batting_walks',
  'player_batting_fantasy_score_parlayplay_',
  'player_batting_fantasy_score_prizepicks_',
  'player_pitching_fantasy_score_prizepicks_',
  'player_fantasy_score_underdog_',
  'player_pitches_thrown',
  'player_strikeouts_combo_',
  'player_hits_ + _runs_ + _rbis_combo_',
  'player_batting_walks_combo_',
  'player_fantasy_score_sportsbattle_',
  'player_pitching_fantasy_score_sportsbattle_',
  'player_batting_fantasy_score_sportsbattle_',
  'player_pitching_fantasy_score_underdog_',
  'player_batting_fantasy_score_underdog_',
  'player_batting_fantasy_score_betr_',
  'player_pitching_fantasy_score_sportsquack_',
];

export const WAGERS_GAME_PROPS: string[] = [
  'first_team_to_score',
  'last_team_to_score',
  'total_goals_odd_even',
  'total_points_odd_even',
  'will_there_be_overtime',
  'race_to_10_points',
  'total_hits_ + _runs_ + _errors',
  'total_hits',
  '3rd_map_team_total',
  '2nd_map_handicap',
  '3rd_map_moneyline',
  '4th_map_round_handicap',
  '4th_map_total_rounds',
  '3rd_map_handicap',
  '5th_map_round_handicap',
  'map_handicap',
  '3rd_map_total_rounds',
  '2nd_map_total_rounds',
  '1st_map_total_rounds',
  '1st_map_moneyline',
  '1st_map_handicap',
  '2nd_map_moneyline',
  '3rd_map_round_handicap',
  '1st_map_round_handicap',
  '4th_map_moneyline',
  '3rd_map_total_kills',
  '5th_map_moneyline',
  'total_maps',
  '3rd_map_team_first_blood',
  '2nd_map_round_handicap',
  '2nd_map_total_kills',
  '1st_map_team_total',
  '2nd_map_team_total',
  '5th_map_total_rounds',
  '3rd_map_kills_handicap',
  '4th_map_team_total',
  '1st_map_team_first_blood',
  '2nd_map_team_destroy_first_inhibitor',
  '1st_map_total_kills',
  '2nd_map_team_first_blood',
  '5th_map_team_total_kills',
  '5th_map_team_total',
  '3rd_map_team_destroy_first_inhibitor',
  '2nd_map_kills_handicap',
  '5th_map_kills_handicap',
  '4th_map_kills_handicap',
  '1st_map_kills_handicap',
  '1st_map_team_destroy_first_inhibitor',
  '2nd_map_total_turrets_destroyed',
  '1st_map_team_first_baron',
  '1st_map_total_turrets_destroyed',
  '3rd_map_team_total_kills',
  '4th_map_team_total_kills',
  '3rd_map_total_turrets_destroyed',
  '1st_map_team_total_kills',
  '2nd_map_team_total_kills',
  'total_rounds_odd_even',

  'first_map_total_rounds',
  'first_map_money_line',
  'first_map_handicap',
  'second_map_money_line',
  'first_map_round_handicap',
  'second_map_total_rounds',
  'second_map_handicap',
  'second_map_round_handicap',
  'second_map_total_kills',
  'first_map_team_total',
  'second_map_team_total',
  'first_map_team_first_blood',
  'second_map_team_destroy_first_inhibitor',
  'first_map_total_kills',
  'second_map_team_first_blood',
  'second_map_kills_handicap',
  'first_map_kills_handicap',
  'first_map_team_destroy_first_inhibitor',
  'second_map_total_turrets_destroyed',
  'first_map_team_first_baron',
  'first_map_total_turrets_destroyed',
  'first_map_team_total_kills',
  'second_map_team_total_kills',

  'third_map_team_total',
  'third_map_money_line',
  'third_map_handicap',
  'third_map_total_rounds',
  'third_map_round_handicap',
  'third_map_total_kills',
  'third_map_team_first_blood',
  'third_map_kills_handicap',
  'third_map_team_destroy_first_inhibitor',
  'third_map_team_total_kills',
  'third_map_total_turrets_destroyed',

  'fourth_map_round_handicap',
  'fourth_map_total_rounds',
  'fourth_map_money_line',
  'fourth_map_team_total',
  'fourth_map_kills_handicap',
  'fourth_map_team_total_kills',

  'fifth_map_round_handicap',
  'fifth_map_money_line',
  'fifth_map_total_rounds',
  'fifth_map_team_total_kills',
  'fifth_map_team_total',
  'fifth_map_kills_handicap',
];

interface StatusProps {
  content: string;
  className: string;
}

interface TransactionStatusProps {
  [key: string]: StatusProps;
}

export const TRANSACTION_STATUS: TransactionStatusProps = {
  CONFIRMED: {
    content: 'transactionHistory.header.status.completed',
    className: 'text-green',
  },
  REJECTED: {
    content: 'transactionHistory.header.status.failed',
    className: 'text-red',
  },
  FAILED: {
    content: 'transactionHistory.header.status.failed',
    className: 'text-red',
  },
  SUBMITTED: {
    content: 'transactionHistory.header.status.inprogress',
    className: 'text-yellow',
  },
  CONFIRMING: {
    content: 'transactionHistory.header.status.inprogress',
    className: 'text-yellow',
  },
  WAITING: {
    content: 'transactionHistory.header.status.inprogress',
    className: 'text-yellow',
  },
  NEW: {
    content: 'transactionHistory.header.status.new',
    className: 'text-yellow',
  },
  USED: {
    content: 'transactionHistory.header.status.used',
    className: 'text-green',
  },
  EXPIRED: {
    content: 'transactionHistory.header.status.expired',
    className: 'text-red',
  },
  SUCCESS: {
    content: 'transactionHistory.header.status.completed',
    className: 'text-green',
  },
  PENDING: {
    content: 'transactionHistory.header.status.pending',
    className: 'text-yellow',
  },
};

export type ChatTabType = {
  key: number;
  labelKey: string;
  isComingSoon: boolean;
};

export const CHAT_TAB: ChatTabType[] = [
  { key: 1, labelKey: 'chatTab.public', isComingSoon: false },
  { key: 2, labelKey: 'chatTab.live', isComingSoon: true },
  { key: 3, labelKey: 'chatTab.result', isComingSoon: true },
  { key: 4, labelKey: 'chatTab.mini-game', isComingSoon: false },
  { key: 5, labelKey: 'chatTab.score-board', isComingSoon: false },
];

export const MAIN_MARKETS_LIST = [
  { id: 1, list: ['point_spread', 'run_line', 'puck_line'] },
  { id: 2, list: ['money_line', 'match_result', 'match_winner', 'fight_result_draw_no_bet_'] },
  {
    id: 3,
    list: [
      'total_runs',
      'total_points',
      'total_goals',
      'total_match_goals_over_under',
      'total_runs_over_under',
      'total_points_over_under',
      'total_goals_over_under',
    ],
  },
];

export const KEY_LANGUAGE_LOCALSTORAGE = 'current_language_terabet';
export const KEY_THEME_LOCALSTORAGE = 'current_theme_teraber';
export const LAST_AUTO_CHANGE_THEME_LOCALSTORAGE = 'last_time_change_theme';
export const DONT_SHOW_EVENT_AT_DATE_LOCALSTORAGE = 'dont_show_event_at_date';

export const MONEY_LINE_MARKET = [
  'money_line',
  'match_result',
  'match_winner',
  'fight_result_draw_no_bet_',
];
